
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { TrackingVariazione } from '@/models';

@Component
export default class ItemListVariazioneOrdineMTM extends Vue {
    @Prop() private variazione!: TrackingVariazione;

    @Emit('conferma-variazione')
    private confermaVariazione()
    {                
        return this.variazione.id;
    }

    private formatValue(value: string, type: string)
    {        
        switch(type){
            case "DateTime":
                return this.$options.filters?.formatDateTime(value) || "";
            default:
                return value;
        }
    }
}
